import { FC, SVGProps } from 'react'

export const MusicComment: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="22"
    viewBox="0 0 27 22"
    fill="none"
    {...props}
  >
    <path
      d="M7.16002 19.1108L7.51116 18.4481L7.20411 18.2854L6.88148 18.4144L7.16002 19.1108ZM2.73903 20.8792L3.01757 21.5755L3.01757 21.5755L2.73903 20.8792ZM1.40287 19.6876L2.12644 19.8849L2.12644 19.8849L1.40287 19.6876ZM2.71527 14.8755L3.43884 15.0728L3.51773 14.7835L3.37548 14.5196L2.71527 14.8755ZM14.0005 21.5C21.0016 21.5 27.0005 17.0134 27.0005 11.125H25.5005C25.5005 15.8681 20.5303 20 14.0005 20V21.5ZM6.80888 19.7735C8.87434 20.8679 11.3492 21.5 14.0005 21.5V20C11.5851 20 9.35253 19.4237 7.51116 18.4481L6.80888 19.7735ZM3.01757 21.5755L7.43856 19.8071L6.88148 18.4144L2.46048 20.1828L3.01757 21.5755ZM0.679299 19.4903C0.299169 20.8841 1.6762 22.1121 3.01757 21.5755L2.46049 20.1828C2.26886 20.2595 2.07214 20.084 2.12644 19.8849L0.679299 19.4903ZM1.9917 14.6781L0.679298 19.4903L2.12644 19.8849L3.43884 15.0728L1.9917 14.6781ZM1.00046 11.125C1.00046 12.5877 1.37881 13.9767 2.05506 15.2313L3.37548 14.5196C2.80926 13.4691 2.50046 12.3232 2.50046 11.125H1.00046ZM14.0005 0.75C6.99933 0.75 1.00046 5.23662 1.00046 11.125H2.50046C2.50046 6.3819 7.47062 2.25 14.0005 2.25V0.75ZM27.0005 11.125C27.0005 5.23662 21.0016 0.75 14.0005 0.75V2.25C20.5303 2.25 25.5005 6.3819 25.5005 11.125H27.0005Z"
      fill="currentColor"
    />
    <path
      d="M15.1667 12.5833C15.1667 13.872 14.122 14.9167 12.8333 14.9167C11.5447 14.9167 10.5 13.872 10.5 12.5833C10.5 11.2947 11.5447 10.25 12.8333 10.25C14.122 10.25 15.1667 11.2947 15.1667 12.5833ZM15.1667 12.5833L15.1666 6.1666L17.4999 8.49993"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
